import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoIconComponent } from './info-icon/info-icon.component';
import { IconModule } from '../icon/icon-module';
import { PadlockIconComponent } from './padlock-icon/padlock-icon.component';

@NgModule({
  declarations: [InfoIconComponent, PadlockIconComponent],
  imports: [CommonModule, IconModule],
  exports: [InfoIconComponent, PadlockIconComponent],
})
export class IconsModule {}
